module.exports = __webpack_public_path__ + "img/sort-down.e5bef118.svg";